import { z } from 'zod';
import { validChallengeId } from './challenge.js';
export const AnalyticsEventSchema = z
    .object({
    id: z.string().uuid(),
    visitor: z.string().uuid(),
    session: z.string().uuid(),
    name: z.enum([
        'landing_view',
        'demo_start',
        'round_complete',
        'share_click',
        'share_copy',
        'referral_visit',
        'room_created',
        'host_activated',
        'audio_error',
        'game_error',
    ]),
    source: z.enum([
        'direct',
        'producthunt',
        'x',
        'youtube',
        'instagram',
        'community',
        'referral',
        'other',
    ]),
    locale: z.enum(['en', 'ja']),
    device: z.enum(['mobile', 'desktop']),
    mode: z.enum(['solo', 'daily', 'multiplayer']).optional(),
    challenge: z.string().max(17).refine(validChallengeId).optional(),
    referral: z
        .string()
        .regex(/^[a-z0-9]{8,24}$/)
        .optional(),
    correct: z.boolean().optional(),
    pct: z.number().int().min(0).max(100).optional(),
})
    .strict();
export const FeedbackSchema = z.object({ message: z.string().trim().min(5).max(1000) }).strict();
//# sourceMappingURL=analytics.js.map